import IntlMessageFormat from 'intl-messageformat';
import { AVAILABLE_LOCALES } from 'shared/constants/locale';
import REGIONS_CITIES from 'shared/constants/json/regions&cities.json';
import dateFnsUk from 'date-fns/locale/uk';
import dateFnsRu from 'date-fns/locale/ru';
import format from 'date-fns/format';
import { compareByTitle } from 'shared/helpers/arrays';

const translateBasic = (string, messages) =>
  typeof string === 'string' && messages[string] ? messages[string] : string;

export const curriedTranslate = messages => (string, data) => {
  if (data) {
    const dat = {};
    Object.keys(data).map((a) => {
      dat[a] = String(data[a]);
      return '';
    });
    return new IntlMessageFormat(translateBasic.call(null, string, messages)).format(dat);
  }
  return translateBasic.call(null, string, messages);
};
export const removeLocaleFromHref = href => {
  const regexp = new RegExp(`/(${AVAILABLE_LOCALES.join('|')})/`);
  return href.replace(regexp, '/');
};

export const toLocalized = (href, locale) => {
  if (
    !href ||
    !locale ||
    locale === AVAILABLE_LOCALES[0] ||
    AVAILABLE_LOCALES.find(l => href.startsWith(`/${l}/`))
  ) {
    return href ? href.replace(/\/\//g, '/') : href;
  }

  return href.startsWith('/')
    ? `/${locale}${href}`.replace(/\/\//g, '/')
    : href.replace(/\/\//g, '/');
};

export const injectLocationIntoHref = (href, locationSlug) =>
  `${href}/${locationSlug}/`.replace(/\/\//g, '/');

export const disableLocation = (seoLocations, location) => {
  if (!seoLocations) return true;

  if (location.is_region) {
    const arr = location.children.map(regItem =>
      seoLocations.find(seoItem => seoItem.id === regItem.id),
    );
    return arr.filter(res => res).length;
  }
  return !!seoLocations.find(item => item.id === location.id);
};

export const setActiveLocations = (seoLocations, selectedLocation) => location => ({
  ...location,
  disabled: !disableLocation(seoLocations, location),
  selectedLocation: selectedLocation && selectedLocation.id === location.id,
});

export const getCurrentLocation = (Geocode, _this, coords, LOCATIONS, Cookies) => {
  const KYIV_PLACE_ID = 'ChIJBUVa4U7P1EARcgG8M175HHk';
  const COOKIES_LOCATION = 'current_location';
  const { latitude, longitude } = coords;

  Geocode.setApiKey('AIzaSyBPak0kWjgy0cLE5vtaHXdbzECMkGu54S0');
  Geocode.setLanguage('ru');

  let cityName = '';

  Geocode.fromLatLng(latitude, longitude).then(
    response => {
      response.results.map(item => {
        if (
          item.types &&
          item.types.includes('administrative_area_level_2') &&
          item.place_id === KYIV_PLACE_ID
        )
          response.results.map(value => {
            if (value.types && value.types.includes('postal_code')) {
              value.address_components.map(data => {
                if (data.types && data.types.includes('locality')) cityName = data.long_name;
              });
            }
          });
        else if (item.types && item.types.includes('postal_code'))
          response.results.map(value => {
            value.address_components.map(data => {
              if (data.types && data.types.includes('locality')) cityName = data.long_name;
            });
          });
      });
      let selLocation = null;

      if (cityName) selLocation = LOCATIONS.find(item => item.title && item.title === cityName);
      if (selLocation) {
        Cookies.set(COOKIES_LOCATION, selLocation);
        _this.props.selectedActions.set.location(selLocation);
      }
    },
    error => {
      console.error(error);
    },
  );
};

export const replaceRegion = string =>
  string.includes('область') ? string.replace('область', 'обл.') : string;

export const getAllLocations = (hideRegions = false) => {
  let allLocations = [];

  allLocations = allLocations
    .concat(...REGIONS_CITIES.map(item => item.children))
    .sort(compareByTitle);

  return hideRegions ? allLocations : [...REGIONS_CITIES, ...allLocations];
};

export const getDateFnsLocale = locale => (locale === AVAILABLE_LOCALES[0] ? dateFnsRu : dateFnsUk);

export const getFormattedDateFns = (date, formatDate, locale) =>
  format(new Date(date), formatDate, {
    locale: getDateFnsLocale(locale || AVAILABLE_LOCALES[1]),
  });



// WEBPACK FOOTER //
// ./src/shared/helpers/locale.js